const tmsPortal = [
  // {
  //     tabName: "Dashboard",
  //     page: [],
  //     path: "/tms/dashboard",
  //     authority: "TMS",
  // },
  {
    tabName: "Devices",
    page: [],
    path: "/tms/devices",
    authority: "TMS_DEVICE",
    rolePermission: "TMS_DEVICE",
  },
  {
    tabName: "Remote View",
    page: [],
    path: "/tms/remote-view",
    authority: "TMS_REMOTE_VIEW",
    rolePermission: "TMS_REMOTE_VIEW",
  },
  {
    tabName: "Applications",
    page: [],
    path: "/tms/applications",
    authority: "TMS_APPLICATION",
    rolePermission: "TMS_APPLICATION",
  },
  // {
  //     tabName: "Customers",
  //     page: [],
  //     path: "/tms/customers",
  //     authority: "TMS",
  // },
  // {
  //     tabName: "RKI",
  //     page: [],
  //     path: "/tms/RKI",
  //     authority: "TMS",
  // },
  // {
  //     tabName: "User Management",
  //     page: [],
  //     path: "/tms/user",
  //     authority: "TMS",
  // },
];

export default tmsPortal;
